import {Input, Component, forwardRef, OnInit, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, Observable, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
declare var $: any;

export const RADIO_BUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ChackBoxRadioComponent),
  multi: true
};

@Component({
  selector: '[checkBoxRadio]',
  templateUrl: 'checkbox-radio.component.html',
  styleUrls: ['./checkbox-radio.component.css'],
  providers: [RADIO_BUTTON_VALUE_ACCESSOR, NgbTooltipConfig]
})
export class ChackBoxRadioComponent implements ControlValueAccessor, OnInit, OnChanges {
  nameFormInput: string;
  @Input() labelInput: string;
  @Input() idInput: string;
  @Input() submitPending: boolean;
  @Input() objectReference: boolean;
  @Input() mandatory: boolean;
  // @Input() showLabel: boolean = true;
  @Input() edit: boolean;
  @Input() control: AbstractControl;
  @Input() classCol: string;
  @Input() labelNotChecked: string = 'No';
  @Input() labelChecked: string = 'Si';
  @Input() labelClass?: string = '';
  @Output() onReturn = new EventEmitter();
  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };
  private _value: any;
  public enableObservable: Observable < boolean >;
  private enableObserver: Observer < boolean > ;
  @Input() highlight: boolean = false;
  @Input() highlightLabel: string = null;
  @Input() ariaLabelNotChecked: string;
  @Input() ariaLabelChecked: string;
  randomValueString = this.getRandomId();

  constructor(private httpService: HttpClient) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.edit) {
      this.nameFormInput = this.edit ? 'mod' : '';
    }
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable < boolean > (observer => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }

    if (!this.classCol) {
      this.classCol = 'col-sm-2';
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getHighlight(condition: string) {
    return this.highlight && this.objectReference + '' === condition ? ' highlight-border-input' : '';
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }
}
